<template>
  <div class="mb-2">

    <b-row>
      <b-col cols="6">
        <b-button type="button" variant="primary" size="sm" v-on:click="toggle">Wettbewerb erstellen</b-button>
      </b-col>

      <b-col cols=6 class="text-right" v-if="competition">
        <b-button type="button" variant="danger" size="sm" @click="$emit('delete')">Löschen</b-button>
        <b-button type="button" variant="primary" size="sm" @click="$emit('edit')">Bearbeiten</b-button>
      </b-col>
    </b-row>


    <div v-if="add" class="mt-2">
      <b-row>
        <b-col>
          <b-form-select :options="countries" v-model="country" class="mb-2"></b-form-select>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group><b-form-input type="text" v-model="name" placeholder="Name"/></b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="text-right">
          <b-btn variant="secondary" size="sm" v-on:click="toggle">Abbrechen</b-btn>
          <b-btn variant="primary" size="sm" v-on:click="create" :disabled="!valid">Erstellen</b-btn>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { getCountries } from '@/lib/locale'

export default {
  name: 'CompetitionEditMenu',
  props: ['competition', 'cols'],
  data: function () {
    return {
      add: false,
      name: '',
      country: null
    }
  },
  computed: {
    valid: function () {
      return this.name !== '' && this.country !== null
    },

    countries: function () {
      const options = [{ value: null, text: 'Land', disabled: true }]
      const countries = getCountries()

      Object.keys(countries).forEach(code => {
        options.push({text: countries[code].name, value: code})
      })

      return options
    }
  },

  methods: {
    toggle: function () {
      this.add = !this.add
      this.$emit('add', this.add)
    },

    create: function () {
      const params = {
        name: this.name.trim(),
        country: this.country
      }

      this.axios.post('/competitions', JSON.stringify(params))
        .then((rsp) => {
          this.name = ''
          this.country = null

          this.$emit('create', rsp.data)
          this.toggle()
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/admin/CompetitionEditMenu.vue